module.exports = __webpack_public_path__ + "img/ToyFaces_Colored_BG_94.8139c8db.jpg";